import { useState } from 'react'
import { Receipt } from 'lucide-react'

import { Button } from '@/common/ui/button'

import CreatePrepaymentModal from './CreatePrepaymentModal'

export default function CreatePrepaymentButton() {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<>
			<Button variant="default" size="sm" onClick={() => setIsOpen(true)}>
				<Receipt className="mr-2 h-4 w-4" />
				ชำระล่วงหน้า
			</Button>
			<CreatePrepaymentModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
		</>
	)
}
